import React from 'react';
import { Moment } from 'moment';
import SideFilter from '../../../../../Components/Filter/SideFilter';
import SideFilterForm from '../../../../../Components/Filter/SideFilterForm/SideFilterForm';
import { ItemScheme } from '../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../Enums/MagicField.enum';
import { useNCZIContext } from '../../../Services/NCZIContext';

export interface ElectronicDPNFilterValues {
	createdFrom?: Moment;
	createdTo?: Moment;
	endValidityFrom?: Moment;
	endValidityTo?: Moment;
	startValidityFrom?: Moment;
	startValidityTo?: Moment;
	includeCancelled?: boolean;
	// includeHistory?: boolean;
	withoutValidityEnd?: boolean;
}

const ElectronicDPNFilterScheme: ItemScheme[] = [
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'nczi.electronicDPN.filter.created',
	},
	{
		type: MagicField.DATEPICKER,
		title: 'nczi.electronicDPN.filter.dateFrom',
		key: 'createdFrom',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.DATEPICKER,
		title: 'nczi.electronicDPN.filter.dateTo',
		key: 'createdTo',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.WHITESPACE,
	},
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'nczi.electronicDPN.filter.endValidity',
	},
	{
		type: MagicField.DATEPICKER,
		title: 'nczi.electronicDPN.filter.dateFrom',
		key: 'endValidityFrom',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.DATEPICKER,
		title: 'nczi.electronicDPN.filter.dateTo',
		key: 'endValidityTo',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.WHITESPACE,
	},
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'nczi.electronicDPN.filter.startValidity',
	},
	{
		type: MagicField.DATEPICKER,
		title: 'nczi.electronicDPN.filter.dateFrom',
		key: 'startValidityFrom',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.DATEPICKER,
		title: 'nczi.electronicDPN.filter.dateTo',
		key: 'startValidityTo',
		settings: {
			hideRequired: true,
		},
	},
	{
		type: MagicField.WHITESPACE,
	},
	{
		type: MagicField.TEXT,
		subType: 'filterLabel',
		title: 'nczi.electronicDPN.filter.recordsLabel',
	},
	{
		type: MagicField.CHECKBOX,
		title: 'nczi.electronicDPN.filter.includeCancelled',
		key: 'includeCancelled',
	},
	{
		type: MagicField.CHECKBOX,
		title: 'nczi.electronicDPN.filter.withoutEnd',
		key: 'withoutValidityEnd',
	},
	// {
	// 	type: MagicField.CHECKBOX,
	// 	title: 'nczi.electronicDPN.filter.showHistory',
	// 	key: 'includeHistory',
	// },
];

interface Props {
	onFilter?: (values: ElectronicDPNFilterValues) => void;
}

const ElectronicDPNFilter: React.FC<Props> = ({ onFilter }) => {
	const { patientDPNFilter, setPatientDPNFilter } = useNCZIContext();

	const handleOnSubmit = (values: any) => {
		setPatientDPNFilter(values as ElectronicDPNFilterValues);
		onFilter?.(values as ElectronicDPNFilterValues);
	};

	return (
		<SideFilter isOpenByDefault={false}>
			<SideFilterForm
				onSubmit={handleOnSubmit}
				formScheme={ElectronicDPNFilterScheme}
				defaultValues={patientDPNFilter ?? {}}
			/>
		</SideFilter>
	);
};

export default ElectronicDPNFilter;
